import React from 'react';

const redirectToHref = () => {
    const href = localStorage.getItem('redirectURL');
    if (href) {
        window.location.href = href;
        localStorage.removeItem('redirectURL');
    } else {
        window.location.href = '/';
    }
};

const Welcome = () => {
    redirectToHref();
    return <></>;
};

export default Welcome;
